import React from 'react';

import { ContentLayout } from '../utilities/layouts/ContentLayout';
import { DetailsLayout } from '../utilities/layouts/DetailsLayout';
import { TermsOfSeviceFullText } from '../setupAccountWizard/TermsOfServiceText';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

export default function TermsAndConditionsPage() {
    const history = useHistory();

    const onPrevClick = () => {
        history.goBack();
    };

    return (
        <DetailsLayout onClick={onPrevClick}>
            <ContentLayout>
                <TermsOfSeviceFullText />
            </ContentLayout>
        </DetailsLayout>
    );
}
